import { useEffect } from 'react';
import { FaHome, FaAngleDoubleLeft, FaAngleLeft, FaAngleRight, FaAngleDoubleRight, FaFileExcel, FaFilePdf } from 'react-icons/fa';
import $ from 'jquery';
import styled from 'styled-components';
import CAT1000 from '../../Tables/Tabledata/OEMMaintenance/AdderView CATx 1000, 16-Ports 2 files 54 Pages/MAN-AVX1008-AVX1016-ADDER 52 Pages.PDF';
import X200 from '../../Tables/Tabledata/OEMMaintenance/AdderView X200 Reciever 2 Files 21 Pages/MAN-X200-EXTENDER_0 19 Pages.PDF';
import AllenBradley from '../../Tables/Tabledata/OEMMaintenance/Allen Bradley/1756-um543_-en-p.pdf';
import AlliedVision from '../../Tables/Tabledata/OEMMaintenance/AlliedVision/Alvium-USB-Cameras_User-Guide 235 Pages.pdf';
import Fuji from '../../Tables/Tabledata/OEMMaintenance/Fuji/HF-XA-5M_OperationManual 2 Pages.pdf';
import DL3801 from '../../Tables/Tabledata/OEMMaintenance/Hewlett Packard/HPE ProLiant DL380 Gen10 Server-a00008180enw.pdf';
import DL3802 from '../../Tables/Tabledata/OEMMaintenance/Hewlett Packard/HPE_a00019109en_us_HPE ProLiant DL380 Gen10 Server User Guide.pdf';
import TripLite1 from '../../Tables/Tabledata/OEMMaintenance/Tripp-Lite Owners-Manual 6 Files 230 Pages/Tripp-Lite-Owners-Manual-753912-1 page.pdf';
import TripLite2 from '../../Tables/Tabledata/OEMMaintenance/Tripp-Lite Owners-Manual 6 Files 230 Pages/Tripp-Lite-Owners-Manual-753913-16 pages.pdf';
import TripLite3 from '../../Tables/Tabledata/OEMMaintenance/Tripp-Lite Owners-Manual 6 Files 230 Pages/Tripp-Lite-Owners-Manual-867789- 44 Pages.pdf';
import TripLite4 from '../../Tables/Tabledata/OEMMaintenance/Tripp-Lite Owners-Manual 6 Files 230 Pages/Tripp-Lite-Owners-Manual-890217-160 Pages.pdf';
import TripLite5 from '../../Tables/Tabledata/OEMMaintenance/Tripp-Lite Owners-Manual 6 Files 230 Pages/Tripp-Lite-Owners-Manual-894513- 8 Pages.pdf';

import Inovision1 from '../../Tables/Tabledata/TrainingDocs/Inovision - Stellantis WTAP SI  Course Description and Outline.pdf';
import Inovision2 from '../../Tables/Tabledata/TrainingDocs/Inovision - Stellantis WTAP SI Evaluation.pdf';
import Inovision3 from '../../Tables/Tabledata/TrainingDocs/Inovision - Stellantis WTAP SI Sign In Sheet.pdf';
import Inovision4 from '../../Tables/Tabledata/TrainingDocs/Inovision - Stellantis WTAP SI Student Handout.pdf';
import Inovision5 from '../../Tables/Tabledata/TrainingDocs/Inovision - Stellantis WTAP SI Task Certification.pdf';

const TableComp = ({ className, tablesorter }) => {
	useEffect(() => {
		$('#myTable')
			.tablesorter({
				theme: 'ice',
				widgets: ['filter', 'zebra', 'cssStickyHeaders', 'pager'],
				widgetOptions: { cssStickyHeaders_attachTo: '.table-container', uitheme: 'jui' },
			})
			.tablesorterPager({
				// target the pager markup - see the HTML block below
				container: $('.pager'),

				// output string - default is '{page}/{totalPages}';
				// possible variables:
				// {page}, {totalPages}, {startRow}, {endRow} and {totalRows}
				output: '{page}/{totalPages} ({startRow}-{endRow})',

				// apply disabled classname to the pager arrows when the rows at
				// either extreme is visible - default is true
				updateArrows: true,

				// starting page of the pager (zero based index)
				page: 0,

				// Number of visible rows - default is 10
				size: 10,

				// if true, the table will remain the same height no matter how many
				// records are displayed. The space is made up by an empty
				// table row set to a height to compensate; default is false
				fixedHeight: true,

				// remove rows from the table to speed up the sort of large tables.
				// setting this to false, only hides the non-visible rows; needed
				// if you plan to add/remove rows with the pager enabled.
				removeRows: false,

				// css class names of pager arrows
				// next page arrow
				cssNext: '.next',
				// previous page arrow
				cssPrev: '.prev',
				// go to first page arrow
				cssFirst: '.first',
				// go to last page arrow
				cssLast: '.last',
				// select dropdown to allow choosing a page
				cssGoto: '.gotoPage',
				// location of where the "output" is displayed
				cssPageDisplay: '.pagedisplay',
				// dropdown that sets the "size" option
				cssPageSize: '.pagesize',
				// class added to arrows when at the extremes
				// (i.e. prev/first arrows are "disabled" when on the first page)
				// Note there is no period "." in front of this class name
				cssDisabled: 'disabled',
			});
	});
	let classes = { className };
	if (tablesorter) {
		classes += 'tablesorter';
	}

	return (
		<table id="myTable" class={classes} style={{ width: '100%' }}>
			<thead>
				<tr>
					<th>Document Description</th>
					<td>File</td>
				</tr>
			</thead>
			<tbody>
				<tr>
					<td>SMARTInspect Course Description and Outline</td>

					<td>
						<a href={Inovision1} target="_blank">
							<FaFilePdf size={50} class="file-link pdf" />
						</a>
					</td>
				</tr>
				<tr>
					<td>WTAP SMARTInspect Evaluation</td>

					<td>
						<a href={Inovision2} target="_blank">
							<FaFilePdf size={50} class="file-link pdf" />
						</a>
					</td>
				</tr>
				<tr>
					<td>WTAP SMARTInspect Sign-In Sheet</td>

					<td>
						<a href={Inovision3} target="_blank">
							<FaFilePdf size={50} class="file-link pdf" />
						</a>
					</td>
				</tr>
				<tr>
					<td>WTAP SMARTInspect Student Handout</td>

					<td>
						<a href={Inovision4} target="_blank">
							<FaFilePdf size={50} class="file-link pdf" />
						</a>
					</td>
				</tr>
				<tr>
					<td>WTAP SMARTInspect Task Certification</td>

					<td>
						<a href={Inovision5} target="_blank">
							<FaFilePdf size={50} class="file-link pdf" />
						</a>
					</td>
				</tr>
			</tbody>
			<tfooter id="pager" className="pager" style={{}}>
				<form>
					<FaAngleDoubleLeft size={30} style={{ color: '#000', margin: '.25rem .5rem' }} className="first" alt="button" />
					<FaAngleLeft size={30} style={{ color: '#000', margin: '.25rem .5rem' }} className="prev" alt="button" />
					<input type="text" className="pagedisplay" alt="button" />
					<FaAngleRight size={30} style={{ color: '#000', margin: '.25rem .5rem' }} className="next" alt="button" />
					<FaAngleDoubleRight size={30} style={{ color: '#000', margin: '.25rem .5rem' }} className="last" alt="button" />
					<select className="pagesize">
						<option selected="selected" value="10">
							10
						</option>
						<option value="20">20</option>
						<option value="30">30</option>
					</select>
				</form>
			</tfooter>
		</table>
	);
};

const Table = styled(TableComp)``;

export default Table;
